module.exports = __webpack_public_path__ + "static/media/DiceSum.12a33c15.jpg";